import { GAME_TYPE } from "constants/game.constants";
import FavoriteResourceCalculator from "../abstraction";
import LocalStorageUtils from "utils/localStorage";
import { PENALTY_SHOOTOUT_GENERATED_MARKET_GROUPS, PENALTY_SHOOTOUT_MARKETS_GROUPS } from "constants/market.constants";

const resourceKey = "favorite-markets-";
class FavoriteMarketsCalculator extends FavoriteResourceCalculator {

	static allowedGames = [
		GAME_TYPE.FOOTBALL_SINGLE_MATCH,
		GAME_TYPE.ENGLISH_LEAGUE,
		GAME_TYPE.AFRICAN_CUP,
		GAME_TYPE.WORLD_CUP,
		GAME_TYPE.ENGLISH_LEAGUE,
		GAME_TYPE.CHAMPIONS_LEAGUE,
		GAME_TYPE.COPA_LIBERTADORES,
		GAME_TYPE.HORSE_STEEPLECHASING,
		GAME_TYPE.PENALTY_SHOOTOUT,
		GAME_TYPE.TURKISH_LEAGUE
	]

	static _instance = null;

	static get instance() {
		return FavoriteMarketsCalculator._instance
	}

	static generateResourcePart = (bet) => {

		let marketGroup = bet.marketGroup;

		switch (bet.gameType) {
			case GAME_TYPE.PENALTY_SHOOTOUT:
				if ([
					PENALTY_SHOOTOUT_MARKETS_GROUPS.HOME_SHOT_OUTCOME,
					PENALTY_SHOOTOUT_GENERATED_MARKET_GROUPS[PENALTY_SHOOTOUT_MARKETS_GROUPS.HOME_SHOT_OUTCOME],
					PENALTY_SHOOTOUT_MARKETS_GROUPS.AWAY_SHOT_OUTCOME,
					PENALTY_SHOOTOUT_GENERATED_MARKET_GROUPS[PENALTY_SHOOTOUT_MARKETS_GROUPS.AWAY_SHOT_OUTCOME]
				].includes(bet.marketGroup)) {
					marketGroup = PENALTY_SHOOTOUT_GENERATED_MARKET_GROUPS.PENALTY_SHOT_OUTCOME
				}
				break;
			default:
				break;
		}

		return `${marketGroup}-${bet.marketPeriod}`;
	}

	increment(resourcePart, gameType) {
		let resource = this.resource;
		let subResource = resource[gameType] ?? {};
		const resourcePartValue = subResource[resourcePart] ?? 0;
		const newResourcePartValue = resourcePartValue + 1;
		subResource[resourcePart] = newResourcePartValue;
		if (newResourcePartValue === Infinity) {
			subResource = this._reassignment(subResource);
		}
		subResource.descSortedKeys = (
			Object.keys(subResource)
				.filter(key => typeof subResource[key] === "number")
				.sort((a, b) => subResource[b] - subResource[a])
		);
		resource[gameType] = subResource;
		LocalStorageUtils.set(this._resourceKey, resource);
	}

	decrement(resourcePart, gameType) {
		let resource = this.resource;
		let subResource = resource[gameType] ?? {};
		const resourcePartValue = subResource[resourcePart] ?? 0;
		const newResourcePartValue = resourcePartValue - 1;
		subResource[resourcePart] = newResourcePartValue;
		if (newResourcePartValue === 0) {
			subResource = this._reassignment(subResource);
		}
		subResource.descSortedKeys = (
			Object.keys(subResource)
				.filter(key => typeof subResource[key] === "number")
				.sort((a, b) => subResource[b] - subResource[a])
		);
		resource[gameType] = subResource;
		LocalStorageUtils.set(this._resourceKey, resource);
	}

	updateByBets(bets) {
		bets.forEach(bet => {
			if (!FavoriteMarketsCalculator.allowedGames.includes(bet.gameType)) {
				return
			}
			if (!bet.marketGroup) {
				return
			}
			const resourcePart = FavoriteMarketsCalculator.generateResourcePart(bet);
			this.increment(resourcePart, bet.gameType)
		})
	}

	constructor(keyPostfix) {
		super(resourceKey + keyPostfix);
		FavoriteMarketsCalculator._instance = this;
	}
}

export default FavoriteMarketsCalculator;